import { createSelector } from 'reselect'

// Actions
export const ACTION_TYPES = {
  RECEIVED_CONVERSATIONS: 'CONVERSATIONS::RECEIVED_CONVERSATIONS',
  SET_ACTIVE_ID: 'CONVERSATIONS::SET_ACTIVE_ID',
  SET_ON_CALL: 'CONVERSATIONS::SET_ON_CALL',
};

// Action Creators
export const setActive = activeId => ({ type: ACTION_TYPES.SET_ACTIVE_ID, activeId });
export const setConversations = conversations => ({
  type: ACTION_TYPES.RECEIVED_CONVERSATIONS,
  conversations,
});
export const setOnCall = onCall => ({ type: ACTION_TYPES.SET_ON_CALL, onCall });

// Selectors
export const getActive = createSelector(
  state => state.conversations.conversations,
  state => state.conversations.activeId,
  (conversations, activeId) => conversations.find(c => c.id === activeId),
);


// Reducer
export default function conversationsReducer(state = {
  conversations: [],
  activeId: null,
  onCall: false,
}, action) {
  switch(action.type) {
    case ACTION_TYPES.RECEIVED_CONVERSATIONS: {
      return {
        ...state,
        conversations: action.conversations,
      }
    }
    case ACTION_TYPES.SET_ACTIVE_ID: {
      return {
        ...state,
        activeId: action.activeId,
      }
    }
    case ACTION_TYPES.SET_ON_CALL: {
      return {
        ...state,
        onCall: action.onCall,
      }
    }
    default : return state;
  }
}
